export default {
  authServiceUrl: 'http://localhost:8001',
  authApiUrl: 'http://localhost:8001/api',
  accApiUrl: 'http://localhost:8002',
  frontSiteUrl: 'http://localhost:8003',
  fileServiceUrl: 'http://localhost:8004',
  commentServiceUrl: 'http://localhost:8005',
  notificationServiceUrl: 'http://localhost:8006',
  clientId: 'dha_accounting_webapp',
  tokenHandleUrl: `${window.location.origin}/auth/token`,
};



// WEBPACK FOOTER //
// ./src/configs/base.js